export const HOME = '/';
